import visa from "./documents-images/visa.jpg"; 
import child from "./documents-images/child.jpg"; 
import medicine from "./documents-images/medicine.jpg";
import driver from "./documents-images/rolando-garrido-R4y4_dvpYXU-unsplash.jpg";
import pet from "./documents-images/krista-mangulsone-9gz3wfHr65U-unsplash.jpg";
import cpf from "./documents-images/cpf.jpeg";
import judge from "./documents-images/judge.jpg";

const documentsData = [
    {
      id: 1,
      title: "Как продлить туристическое пребывание на 90 дней?",
      picture: visa,
      date: "08 апреля 2025",
      excerpt: "Инструкция по продлению",
      link: "/documents/visa-extension",
    },
    {
      id: 2,
      title: "Как оформить гражданство Бразилии для ребёнка до 10 лет?",
      picture: child,
      date: "09 апреля 2025",
      excerpt: "Подробный гайд",
      link: "/documents/child-citizenship",
    },
    {
      id: 3,
      title: "Как получить бесплатную медицинскую страховку?",
      picture: medicine,
      date: "09 апреля 2025",
      excerpt: "Гайд по оформлению SUS",
      link: "/documents/sus",
    },
        {
      id: 4,
      title: "Как получить водительские права?",
      picture: driver,
      date: "26 мая 2025",
      excerpt: "Гайд по замене водительских прав",
      link: "/documents/driver-license",
    },
    {
      id: 5,
      title: "Как перевезти домашнего питомца в Бразилию?",
      picture: pet,
      date: "26 мая 2025",
      excerpt: "Подробный гайд",
      link: "/documents/pet",
    },
    {
      id: 6,
      title: "Как оформить CPF?",
      picture: cpf,
      date: "02 июля 2025",
      excerpt: "Инструкция по оформлению CPF онлайн",
      link: "/documents/cpf",
    },
        {
      id: 7,
      title: "Справки об отсутствии судимости",
      picture: judge,
      date: "02 июля 2025",
      excerpt: "Как оформить справки для Санта Катарины",
      link: "/documents/background",
    },
  ];
  
  export default documentsData;